import { useInView } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CountryBuildingsBannersNew } from 'shared/components/CountryBuildingsBannersNew';

import { trackSuburbanBannerClick, trackSuburbanBannerScroll } from './tracking';
import { offerDataSelector } from '../../selectors/offerData/offerDataSelector';
import { showSuburbanBuildingsBanners } from '../../selectors/showSuburbanBuildingsBanners';
import { getRandomId } from '../../utils/banners';

const PR1_RANDOM_TGB1 = getRandomId();
const PR1_RANDOM_TGB2 = getRandomId();
const PR1_RANDOM_TGB3 = getRandomId();
const PR1_RANDOM_TGB4 = getRandomId();

export const CountryBuildingsBannersContainer = () => {
  const [loaded, setLoaded] = React.useState(false);

  const { offer, user } = useSelector(offerDataSelector);
  const showBanners = useSelector(showSuburbanBuildingsBanners);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  /* istanbul ignore next */
  const handleBannerClick = React.useCallback(() => {
    trackSuburbanBannerClick(offer);
  }, [offer]);

  /* istanbul ignore next */
  const handleLoad = React.useCallback(() => {
    setLoaded(true);
  }, [setLoaded]);

  /* istanbul ignore next */
  React.useEffect(() => {
    if (inView) {
      trackSuburbanBannerScroll(offer);
    }
  }, [inView, offer]);

  if (!showBanners) {
    return null;
  }

  return (
    <div ref={ref}>
      <CountryBuildingsBannersNew
        offer={offer}
        user={user}
        bannerIds={[PR1_RANDOM_TGB1, PR1_RANDOM_TGB2, PR1_RANDOM_TGB3, PR1_RANDOM_TGB4]}
        onLoad={handleLoad}
        onBannerClick={handleBannerClick}
        visible={loaded}
      />
    </div>
  );
};
